import providerData from '@App/data/provider.zava.json';
import { Box, Button, Grid, Typography } from '@material-ui/core';
import React from 'react';

import appStoreLogo from '../../assets/logo/logo-appstore.svg';
import googlePlayLogo from '../../assets/logo/logo-google-play.svg';
import { Modal } from '../../atoms/Modal/Modal';

const contentAppModal = (
  <>
    <Box pt={2}>
      <Typography variant="body1">
        Für Ihre ärztliche Videosprechstunde benötigen Sie ein Smartphone auf welches die kostenlose App{' '}
        <Box component="span" fontWeight="fontWeightBold">
          {providerData.appDetails.name}
        </Box>{' '}
        von{' '}
        <Box component="span" fontWeight="fontWeightBold">
          {providerData.appDetails.author}
        </Box>{' '}
        installiert werden muss. Innerhalb der App erfolgt eine Terminabsprache sowie die anschließende
        Videosprechstunde.
      </Typography>
    </Box>
    <Box pt={2}>
      <Typography variant="subtitle1">Jetzt kostenlose App für die Videosprechstunde installieren:</Typography>
    </Box>
    <Box pt={2}>
      <Grid container spacing={2}>
        <Grid item xs={5} md={4}>
          <a href={providerData.appDetails.urls.ios} id="treatmentnow_app_zava_ios">
            <img className="u-margin--right u-margin--bottom@small-tiny" width="100%" src={appStoreLogo} />
          </a>
        </Grid>
        <Grid item xs={5} md={4}>
          <a href={providerData.appDetails.urls.android} id="treatmentnow_app_zava_google">
            <img className="u-margin--right u-margin--bottom@small-tiny" width="100%" src={googlePlayLogo} />
          </a>
        </Grid>
      </Grid>
    </Box>
  </>
);

const modalTrigger = (
  <Button color="primary" variant="contained" fullWidth id="ods_video_consultation_book_now">
    Jetzt Videosprechstunde buchen
  </Button>
);

export function NotificationAppModal() {
  return (
    <>
      <Modal title="Kostenlose App notwendig" includesTrigger trigger={modalTrigger}>
        {contentAppModal}
      </Modal>
    </>
  );
}
